// extracted by mini-css-extract-plugin
export default {"container":"_WnivS","webinar":"Rb92Fk","content":"htEjye","title":"uRp2jx","dateTime":"SQgM8T","label":"pBAoCK","textField":"WDqIY_","mobileContainer":"EeuMEV"};